// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2eEy9","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2pTKX"};